<p-button (onClick)="op.toggle($event)" [icon]="iconClass" class="button-phones" styleClass="bg-primary"/>

<p-overlayPanel #op [showCloseIcon]="true" [dismissable]="false" (onHide)="reset()">
  <ng-template pTemplate="content">
    <h4 class="pt-4 ps-4  pb-0">{{ headerTitle }}</h4>
    <div class="flex flex-column gap-3 w-25rem">
      <div class="modal-body pt-1">
        <table class="table table-responsive-md  table-hover table-hover">
          <thead>
          <tr>
            <th scope="col" class="text-sm-start text-dark">{{ 'general.title' | translate }}</th>
            <th scope="col" *ngIf="type === 'phoneNumbers' || type === 'relativePhones'" class="text-sm-start text-dark">Ülke Kodu
            </th>
            <th scope="col" class="text-sm-start text-dark">{{ columnTitle }}</th>
            <th scope="col" class="text-sm-start text-dark">Öncelik</th>
            <th scope="col" class="text-sm-end text-dark">
              <button type="button" class="btn btn-sm btn-warning btn-icon-xxs me-1"
                      (click)="newHeadItem()">
                <i
                  class="fas fa-add"></i></button>
            </th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngIf="newContactItem">
            <tr>
              <td>
                <input type="text" class="form-control form-control-sm" [(ngModel)]="newContactData.name"
                       placeholder="{{'general.title' | translate}}">
              </td>
              <td *ngIf="type === 'phoneNumbers' || type === 'relativePhones'">
                <p-dropdown
                  [options]="countries"
                  [(ngModel)]="newContactData.prefixValue"
                  [filter]="true"
                  filterBy="name"
                  optionLabel="label"
                  optionValue="value"
                  appendTo="body"
                >
                  <ng-template let-country pTemplate="item">
                    <div class="country-option d-flex align-items-center">
                      <div [innerHtml]="country.flag | safeHtml">
                      </div>
                      <span>{{ country.label }}</span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </td>
              <td>
                <input
                  *ngIf="type === 'relativePhones'"
                  type="text"
                  class="form-control form-control-sm"
                  [(ngModel)]="newContactData.relativePhone"
                  (ngModelChange)="onRelativePhoneInput($event)"
                  placeholder="Telefon Numarası"
                  required
                  minlength="4"
                  maxlength="15"
                  pattern="^\d+$"
                >

                <input
                  *ngIf="type === 'phoneNumbers'"
                  type="text"
                  class="form-control form-control-sm"
                  [(ngModel)]="newContactData.phone"
                  (ngModelChange)="onPhoneInput($event)"
                  placeholder="Telefon Numarası"
                  required
                  minlength="4"
                  maxlength="15"
                  pattern="^\d+$"
                >

                <input
                  *ngIf="type === 'emails'"
                  type="email"
                  class="form-control form-control-sm"
                  [(ngModel)]="newContactData.email"
                  (ngModelChange)="onEmailInput($event)"
                  placeholder="E-Posta Adresi"
                >
              </td>
              <td class="text-center">
                <input
                  class="form-check-input "
                  type="checkbox"
                  role="switch"
                  [(ngModel)]="newContactData.priority"
                  aria-checked="true"
                />
              </td>
              <td>
                <button *ngIf="type === 'phoneNumbers'"
                        class="btn btn-sm btn-primary float-right"
                        (click)="addContact(newContactData)"
                        [disabled]="!isPhoneValid()">
                  Ekle
                </button>
                <button *ngIf="type === 'relativePhones'"
                        class="btn btn-sm btn-primary float-right"
                        (click)="addContact(newContactData)"
                        [disabled]="!isRelativePhoneValid()">
                  Ekle
                </button>
                <button *ngIf="type === 'emails'"
                        class="btn btn-sm btn-primary float-right"
                        (click)="addContact(newContactData)"
                        [disabled]="!isEmailValid()">
                  Ekle
                </button>
              </td>
            </tr>
          </ng-container>

          <ng-container *ngFor="let item of contactItems; let i = index">

            <ng-container *ngIf="isEditing!=item; else editingRow">
              <tr>
                <td>{{ item?.name }}</td>
                <td *ngIf="type === 'phoneNumbers' || type === 'relativePhones'"
                    class="ps-3 width-xs">{{ item?.prefixValue }}
                </td>
                <td *ngIf="type === 'phoneNumbers' "> {{ item?.phone }}</td>
                <td *ngIf="type === 'relativePhones' "> {{ item?.relativePhone }}</td>
                <td *ngIf="type === 'emails' "> {{ item?.email }}</td>
                <td class="text-center">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [checked]="item.priority"
                    disabled
                  />
                </td>
                <td class="width-xs">
                  <div class="float-right">
                    <button type="button" class="btn btn-sm btn-warning btn-icon-xxs me-1"
                            (click)="isEditing==item?isEditing=null:isEditing=item">
                      <i
                        class="fas fa-pencil-alt"></i></button>
                    <button type="button" class="btn btn-sm btn-danger btn-icon-xxs"
                            (click)="deleteItem(i)"><i
                      class="fas fa-trash-alt"></i></button>
                  </div>
                </td>
              </tr>
            </ng-container>

            <ng-template #editingRow>
              <tr>
                <td>
                  <input type="text" class="form-control form-control-sm" [(ngModel)]="item.name"
                         placeholder="{{'general.title' | translate}}">
                </td>
                <td *ngIf="type === 'phoneNumbers' || type === 'relativePhones'">
                  <p-dropdown
                    [options]="countries"
                    [filter]="true"
                    [(ngModel)]="item.prefixValue"
                    placeholder="Kod"
                    optionLabel="label"
                    optionValue="value"
                    appendTo="body"
                  >
                    <ng-template let-country pTemplate="item">
                      <div class="country-option d-flex align-items-center">
                        <div [innerHtml]="country.flag | safeHtml">
                        </div>
                        <span>{{ country.label }}</span>
                      </div>
                    </ng-template>
                    +
                  </p-dropdown>
                </td>
                <td>
                  <input *ngIf="type === 'phoneNumbers' " type="text" class="form-control form-control-sm"
                         [(ngModel)]="item.phone"
                         placeholder="Telefon Numarası">
                  <input *ngIf="type === 'relativePhones' " type="text" class="form-control form-control-sm"
                         [(ngModel)]="item.phone"
                         placeholder="Telefon Numarası">
                </td>

                <td class="text-center">
                  <input
                    class="form-check-input "
                    type="checkbox"
                    role="switch"
                    [(ngModel)]="item.priority"
                    aria-checked="true"
                  />
                </td>
                <td>
                  <div class="float-right">
                    <button type="button" class="btn btn-sm btn-warning btn-icon-xxs me-1" (click)="saveItem(item)"
                    ><i class="fas fa-save"></i></button>
                    <button type="button" class="btn btn-sm btn-danger btn-icon-xxs"
                            (click)="isEditing==item?isEditing=null:isEditing=item"><i
                      class="fas fa-close"></i></button>
                  </div>
                </td>
              </tr>
            </ng-template>

          </ng-container>
          </tbody>
        </table>

      </div>
    </div>
  </ng-template>

</p-overlayPanel>
